type EventHandler<T = any> = (payload?: T) => void

class EventBus {
  private events: Map<string, Set<EventHandler>> = new Map()

  on<T = any>(event: string, handler: EventHandler<T>) {
    if (!this.events.has(event)) this.events.set(event, new Set())
    this.events.get(event)!.add(handler as EventHandler)
    return () => this.off(event, handler)
  }

  off<T = any>(event: string, handler: EventHandler<T>) {
    const set = this.events.get(event)
    if (!set) return
    set.delete(handler as EventHandler)
    if (set.size === 0) this.events.delete(event)
  }

  emit<T = any>(event: string, payload?: T) {
    const set = this.events.get(event)
    if (!set) return
    set.forEach(fn => fn(payload))
  }
}

export const eventBus = new EventBus()
